import account from '@/core/routes/paths/panel/account'
import home from "@/core/routes/paths/panel/home";
import roles from "@/core/routes/paths/panel/roles";
import admins from "@/core/routes/paths/panel/admins";
import colleagues from "@/core/routes/paths/panel/colleagues";
import settings from "@/core/routes/paths/panel/settings";
import sections from "@/core/routes/paths/panel/sections";
import newsletter from "@/core/routes/paths/panel/newsletter";
import posts from "@/core/routes/paths/panel/posts";
import files from "@/core/routes/paths/panel/files";
import logs from "@/core/routes/paths/panel/logs";
import reports from "@/core/routes/paths/panel/reports";
import pages from "@/core/routes/paths/panel/pages";
import company from "@/core/routes/paths/panel/company";
import research from "@/core/routes/paths/panel/research-plans";
import instruction from "@/core/routes/paths/panel/instruction";
import groups from "@/core/routes/paths/panel/groups";
import team from "@/core/routes/paths/panel/team-members";
import members from "@/core/routes/paths/panel/members";
import forms from "@/core/routes/paths/panel/forms";
import communities from "@/core/routes/paths/panel/communities";

export default [
    {
        path: "/",
        redirect: '/home',
        component: () => import("@/layout/Master"),
        children: [
            ...home,
            ...account,
            ...roles,
            ...admins,
            ...colleagues,
            ...settings,
            ...newsletter,
             ...posts,
            ...files,
            ...reports,
            ...logs,
            ...pages,
            ...sections,
            ...company,
            ...research,
            ...instruction,
            ...groups,
            ...team,
            ...members,
            ...forms,
            ...communities,
         ]
    }
]

